// Порядок фото в окне публикации.
//
// Фото там двух видов: снимки сохранённого черновика (адреса
// /api/ad-drafts/:id/images/:n) и свои файлы, добавленные сейчас, — в том числе
// забранные граббером. Раньше черновые всегда шли первыми, свои — за ними, и
// переставить их между собой было нельзя. Теперь порядок общий: список
// «жетонов» поверх двух наборов.
//
// Жетон — { kind: "draft", url } или { kind: "file", file } (сам объект File).
// Наборы правятся как прежде (добавление, удаление, отбрасывание повторов), а
// порядок к ним подстраивается сам: жетоны пропавших снимков отбрасываются,
// новые встают в конец (если порядка ещё нет — черновые, потом свои, как было).

export const buildPhotoSequence = (order, draftUrls, files) => {
  const urls = (Array.isArray(draftUrls) ? draftUrls : [])
    .map((url) => String(url || "").trim())
    .filter(Boolean);
  const fileList = Array.isArray(files) ? files : [];
  const urlSet = new Set(urls);
  const fileSet = new Set(fileList);
  const usedUrls = new Set();
  const usedFiles = new Set();
  const sequence = [];
  for (const token of Array.isArray(order) ? order : []) {
    if (token?.kind === "draft") {
      const url = String(token.url || "").trim();
      if (!urlSet.has(url) || usedUrls.has(url)) continue;
      usedUrls.add(url);
      sequence.push({ kind: "draft", url });
    } else if (token?.kind === "file") {
      if (!fileSet.has(token.file) || usedFiles.has(token.file)) continue;
      usedFiles.add(token.file);
      sequence.push({ kind: "file", file: token.file });
    }
  }
  for (const url of urls) {
    if (usedUrls.has(url)) continue;
    usedUrls.add(url);
    sequence.push({ kind: "draft", url });
  }
  for (const file of fileList) {
    if (usedFiles.has(file)) continue;
    usedFiles.add(file);
    sequence.push({ kind: "file", file });
  }
  return sequence;
};

export const moveInSequence = (sequence, fromIndex, toIndex) => {
  const list = Array.isArray(sequence) ? [...sequence] : [];
  if (fromIndex === toIndex || fromIndex < 0 || fromIndex >= list.length || toIndex < 0 || toIndex >= list.length) {
    return list;
  }
  const [moved] = list.splice(fromIndex, 1);
  list.splice(toIndex, 0, moved);
  return list;
};

// Что уходит на сервер: файлы — в порядке сетки, черновые адреса — тоже, и
// сам порядок: { kind: "existing", url } для чернового снимка, { kind: "new",
// index } — номер среди отправленных файлов. Так же отправляет порядок окно
// правки объявления, и сервер раскладывает снимки ровно по нему.
export const buildPublishPhotoPayload = (sequence) => {
  const files = [];
  const draftUrls = [];
  const photoOrder = [];
  for (const item of Array.isArray(sequence) ? sequence : []) {
    if (item?.kind === "draft") {
      draftUrls.push(item.url);
      photoOrder.push({ kind: "existing", url: item.url });
    } else if (item?.kind === "file") {
      photoOrder.push({ kind: "new", index: files.length });
      files.push(item.file);
    }
  }
  return { files, draftUrls, photoOrder };
};
